<template>
  <button
    class="button-primary"
    :class="{
      [size]: true,
      block,
    }"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'large',
    },
    block: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-primary {
  @include styled-button;

  background-color: $primary;
  color: white;
  font-weight: 700;
  padding: 25px 35px;
  box-shadow: 3px 10px 20px 0 rgba(0,0,0,0.2);
  margin: 0 auto;
  &:hover {
    background-color: white;
    color: $primary;
  }
  &.small {
    font-size: 16px;
    padding: 16px 35px;
  }
  &.block {
    display: block;
    width: 80%;
  }
  & + & {
    margin-left: 20px;
  }
  &[disabled] {
    opacity: 0.5;
  }
  @media screen and (min-width: $screen-md) {
    padding: 25px 70px;
    &.small {
      padding: 16px 50px;
    }
  }
}
</style>
